let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fFopZ")).then(() => parcelRequire('kSakt'));